import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HomeCarousel from "../customer/Components/Carousel/HomeCarousel";
import { homeCarouselData } from "../customer/Components/Carousel/HomeCaroselData";
import HomeProductGrid from "../customer/Components/Home/HomeProductGrid";
import api from "../config/api";

const Homepage = () => {
    const { auth } = useSelector((store) => store);
    const [seasonalProducts, setSeasonalProducts] = useState([]);
    const [tropicalProducts, setTropicalProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);

                // Fetch seasonal fruits (seasonal_produce category)
                const seasonalResponse = await api.get(
                    `/api/products?color=&size=&minPrice=0&maxPrice=100000&minDiscount=0&category=seasonal_produce&stock=null&sort=price_low&pageNumber=0&pageSize=8`
                );
                console.log("Homepage - Seasonal response:", seasonalResponse.data);
                const seasonalData = seasonalResponse.data?.content || [];
                console.log("Homepage - Seasonal products count:", seasonalData.length);

                // Sort to move Gongura to the end
                const sortedSeasonalData = [...seasonalData].sort((a, b) => {
                    const aIsGongura = a.title?.toLowerCase().includes('gongura');
                    const bIsGongura = b.title?.toLowerCase().includes('gongura');
                    if (aIsGongura && !bIsGongura) return 1;  // Move Gongura to end
                    if (!aIsGongura && bIsGongura) return -1; // Keep other items before Gongura
                    return 0; // Maintain original order for other items
                });
                setSeasonalProducts(sortedSeasonalData);

                // Fetch tropical fruits (fresh_fruits category)
                const tropicalResponse = await api.get(
                    `/api/products?color=&size=&minPrice=0&maxPrice=100000&minDiscount=0&category=fresh_fruits&stock=null&sort=price_low&pageNumber=0&pageSize=8`
                );
                let tropicalData = (tropicalResponse.data?.content || []).filter(product => {
                    const title = product.title?.toLowerCase() || '';
                    return !title.includes('gongura') && !title.includes('moringa');
                });

                // If not enough tropical products, supplement with seasonal
                if (tropicalData.length < 4 && seasonalData.length > 0) {
                    const needed = 8 - tropicalData.length;
                    tropicalData = [...tropicalData, ...seasonalData.slice(0, needed)];
                }
                setTropicalProducts(tropicalData);

                setLoading(false);
            } catch (error) {
                console.error("Error fetching products:", error);
                setLoading(false);
            }
        };

        fetchProducts();
    }, [auth.user]); // Refetch products when auth state changes (after login)

    return (
        <div className="">
            <HomeCarousel images={homeCarouselData} />

            <div className="space-y-10 py-5 bg-white">
                <HomeProductGrid data={seasonalProducts} section={"What's In Season"} loading={loading} />
                <HomeProductGrid data={tropicalProducts} section={"Tropical Fruits"} loading={loading} />
                {/* Best Sellers shows the same seasonal fruits */}
                <HomeProductGrid data={seasonalProducts} section={"Best Sellers"} loading={loading} />
            </div>
        </div>
    );
};

export default Homepage;
